<template>
    <div>
        <string-renderer v-if="(field.field_type === 'URL' || field.field_type === 'String') && fieldValue"
                         :field="field" :document="document" :component="component"
                         :containerWidth="containerWidth"></string-renderer>


<!--        <label-renderer v-else-if="field.field_type === 'String' && isLabel && fieldValue" :component="getComponent(component)"></label-renderer>-->

<!--        <header-renderer v-else-if="field.field_type === 'String' && isHeader && fieldValue" :component="getComponent(component)"></header-renderer>-->


        <text-renderer v-else-if="field.field_type === 'Text' && fieldValue && component && component.component" class="rich-text mb-1"
                       :component="component.component" :text-value="fieldValue"
                        :containerWidth="containerWidth"></text-renderer>

        <div v-else-if="field.field_type === 'Text' && renderText && fieldValue" class="rich-text mb-1">
            <div v-html="fieldValue"></div>
        </div>

        <select-view v-else-if="field.field_type === 'Single Select'" :document="document"
                     :field="field"></select-view>

        <date-renderer v-else-if="field.field_type === 'Date' && fieldValue"
                       :document="document" :field="field"></date-renderer>

        <div v-else-if="field.field_type === 'Collaborator' && fieldValue">
            {{field.name}}: <span class="badge text-bg-light">{{fieldValue.name}}</span>
        </div>

        <div v-else-if="field.field_type === 'Boolean'" class="my-2 d-flex align-items-center">
            <div class="me-2">{{field.name}}</div>
            <checkbox-view :document="document"
                           :field-name="field.index" :editable="false" :key="field.id + 'view'"
                           :table="table" alignment-class="justify-content-left"></checkbox-view>
        </div>

        <attachment-viewer v-else-if="field.field_type === 'Attachment'" :attachments="fieldValue"
                           :document="document" :field="field" :table="table" :image-size="50"></attachment-viewer>

        <number-renderer v-else-if="isNumeric && fieldValue" :document="document" :field="field" class="mb-3"></number-renderer>

        <image-renderer v-else-if="renderImage" :component="imageComponent"></image-renderer>
    </div>
</template>

<script>
    import SelectView from "../../components/SelectView.vue";
    import DateRenderer from "../../components/DateRenderer.vue";
    import StringRenderer from "../../components/StringRenderer.vue";
    import NumberRenderer from "./NumberRenderer.vue";
    import FieldUtil from "../../utils/FieldUtil";
    import AttachmentViewer from "../controls/AttachmentViewer.vue";
    import CheckboxView from "../../components/CheckboxView.vue";
    import ImageRenderer from "./ImageRenderer.vue";
    import PageFactory from "../../utils/PageFactory";
    import LabelRenderer from "./LabelRenderer.vue";
    import HeaderRenderer from "./HeaderRenderer.vue";
    import TextRenderer from "./TextRenderer.vue";

    export default {
        name: 'FieldRenderer',
        components: {
            TextRenderer,
            HeaderRenderer,
            LabelRenderer,
            ImageRenderer,
            CheckboxView, AttachmentViewer, NumberRenderer, StringRenderer, DateRenderer, SelectView},
        props: ['field', 'document', 'table', 'component', 'containerWidth', 'renderText'],
        computed: {
            fieldValue() {
                return this.document[this.field.index]
            },
            isNumeric() {
                return new FieldUtil(this.field).isNumeric()
            },
            imageComponent() {
                let imageObject = this.fieldValue

                if(this.component && this.component.component) {
                    let newImageComponent = JSON.parse( JSON.stringify(this.component.component) )
                    newImageComponent.value = imageObject
                    return newImageComponent
                }

                let pageFactory = new PageFactory()
                return pageFactory.createImageComponent(imageObject)
            },
            renderImage() {
                if(this.field.field_type !== 'Image') {
                    return false
                }

                if(!this.fieldValue) {
                    return false
                }

                if(this.component && this.component.metadata && this.component.metadata.isBackgroundImage ) {
                    return false
                }

                return true
            },
            hasChildComponent() {
                return !!(this.component.component && this.component.component.type)
            },
            isLabel() {
                return this.hasChildComponent && this.component.component.type === 'Label'
            },
            isHeader() {
                return this.hasChildComponent && this.component.component.type === 'Header'
            },
        },
        data () {
            return {
                model: webase.model
            }
        },
        methods: {
            getComponent(component) {
                component.component.value = this.fieldValue
                return JSON.parse(JSON.stringify(component.component))
            }
        }
    }
</script>

<style>

</style>
